export const roundTo5Cents = (numb) => {
  let number = (Math.ceil(numb * 20 - 0.5) / 20).toFixed(2);
  return Math.round((parseFloat(number) + Number.EPSILON) * 100) / 100;
};
